'use client'

import { classMerge } from '@components/utilities/classMerge'
import { getScrollAnimationsForRef } from '@lib/animation/getScrollAnimationsForRef'
import { useEffect, useRef } from 'react'
import { TRIAL_APPLY_FORM_ID } from './TrialApplyFooter.client'

export default function TrialApplyQuestionContainer({
  children,
  childrenClassName,
}: {
  children: React.ReactNode
  childrenClassName?: string
}) {
  const questionContainerRef = useRef(null)
  const { scrollIn, scrollOut } =
    getScrollAnimationsForRef(questionContainerRef)

  useEffect(() => {
    const form = document.getElementById(TRIAL_APPLY_FORM_ID)
    if (form) {
      form.addEventListener('submit', scrollOut)
    }
    scrollIn()
    return () => form?.removeEventListener('submit', scrollOut)
  }, [])

  return (
    <div
      className='grid w-full max-w-6xl grid-cols-1 justify-center overflow-y-auto px-4 pb-48 opacity-0 md:px-8'
      ref={questionContainerRef}
    >
      <div className={classMerge('mx-auto', childrenClassName)}>{children}</div>
    </div>
  )
}
